export enum ContextTypes {
  CLUSTER = 'cluster',
  MODULE = 'module',
  DEVICE = 'device',
  MANAGEMENT = 'management'
}
